import type { UiMessageType } from '~/shared/constants/uiMessage'

import { UI_MESSAGE_TYPE } from '~/shared/constants/uiMessage'

// This is a type of message that wants to be shown
export type UiMessage = {
  // main
  show: boolean
  title?: string
  // appearance
  type?: UiMessageType
}

export const NO_MESSAGE = {
  show: false,
} as const

export const getPriority = (type?: UiMessageType): number => {
  switch (type) {
    case UI_MESSAGE_TYPE.ERROR:
      return 4
    case UI_MESSAGE_TYPE.WARNING:
      return 3
    case UI_MESSAGE_TYPE.INFO:
      return 2
    case UI_MESSAGE_TYPE.SUCCESS:
      return 1
    default:
      return 0
  }
}
